import type { Schema } from "@/shared/components/Form/types";
import type { EditSchemaDefinition } from "@/shared/components/CRUD/types";
import { ContentShowQuery } from "@/admin/entities/contents";
import type { ContentShowQueryQueryType } from "@/types/graphql/admin.generated";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";
import { StreamStatusType } from "@/admin/entities/streams";

export const filterSchema: Schema = {
  search: {
    label: "Поиск",
    type: "text",
    placeholder: "Поиск по названию...",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "primary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  streamStatus: {
    label: "Статус эфира",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все статусы", value: "" },
      { label: "Ожидает", value: StreamStatusType.PendingType },
      { label: "В эфире", value: StreamStatusType.StartedType },
      { label: "Завершён", value: StreamStatusType.FinishedType },
    ],
  },
  deleted: {
    label: "Показывать удалённые",
    type: "switch",
    priority: "secondary",
    xs: 12,
    md: 6,
    fullWidth: true,
  },
};

export const editSchema: EditSchemaDefinition = {
  details: {
    label: "Детали",
    type: "show" as const,
    getTitle: (data: unknown) => {
      const { content } = data as ContentShowQueryQueryType;
      if (!content) return null;
      return content.title;
    },
    showQuery: ContentShowQuery,
  },
} as const;
